// ページ表示をアクセス数として記録する（受け口: PageViewsController#create）
// サーバー側のGETではなくJavaScriptから送ることで、JavaScriptを動かさないボットを数えないようにする。
// Turboのページ移動でも発火するよう turbo:load ごとに送る。集計対象外の判定はサーバー側で行う。
document.addEventListener("turbo:load", () => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (!token) return

  fetch("/page_views", {
    method: "POST",
    credentials: "same-origin",
    // ページ遷移中でも送信を打ち切らせない
    keepalive: true,
    headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
    body: JSON.stringify({ path: window.location.pathname })
  }).catch(() => {
    // 記録の失敗は閲覧に影響させない
  })
})
